import _ from 'lodash'

const fileDownloads = {

  state: {
    pendingDownloads: []
  },

  mutations: {
    addPendingDownload (state, fileData) {
      state.pendingDownloads.push(fileData)
    },

    updatePendingDownload (state, fileData) {
      const index = _.findIndex(state.pendingDownloads, { id: fileData.id })

      if (index !== -1) {
        state.pendingDownloads[index].progress = _.get(fileData, 'progress', null)
      }
    },

    removeDownload (state, fileId) {
      const index = _.findIndex(state.pendingDownloads, { id: fileId })
      if (index !== -1) {
        state.pendingDownloads.splice(index, 1)
      }
    }
  },

  getters: {
    hasPendingExports: state => {
      return state.pendingDownloads.length
    },

    selectionDownloads: state => {
      return _.filter(state.pendingDownloads, { source: 'fileselection' })
    },

    organizedDownloads: state => {
      return _.filter(state.pendingDownloads, { source: 'downloadall-organized' })
    },

    unorganizedDownloads: state => {
      return _.filter(state.pendingDownloads, { source: 'downloadall-unorganized' })
    },

    hasSelectionDownloadPending: state => {
      const index = _.findIndex(state.pendingDownloads, { source: 'fileselection' })

      if (index !== -1) {
        return true
      }

      return false
    },

    hasOrganizedFileArchivePending: state => {
      return _.some(state.pendingDownloads, { source: 'downloadall-organized' })
    },

    hasUnorganizedFileArchivePending: state => {
      return _.some(state.pendingDownloads, { source: 'downloadall-unorganized' })
    }
  }

}

export default fileDownloads



// WEBPACK FOOTER //
// ./src/store/modules/fileDownloads.js